interface OtcOnlyOrderShape {
  otcProducts?: unknown[] | null
  rxFillRequests?: unknown[] | null
}

const isOtcOnlyOrder = (order: OtcOnlyOrderShape): boolean =>
  !!order.otcProducts?.length && !order.rxFillRequests?.length

export default isOtcOnlyOrder
